import { createAction, props } from "@ngrx/store";
import { VigilantApiDtosUsersGetResponse } from "./users.model";

const prefix = "Users.";

/**
 * Action to set users in the store.
 *
 * @property {VigilantApiDtosUsersGetResponse[]} users - An array of user objects to be set.
 */
export const SetUsers = createAction(`${prefix}SetUsers`, props<{ users: VigilantApiDtosUsersGetResponse[] }>());

/**
 * Action to reset the users state.
 */
export const ResetUsers = createAction(`${prefix}ResetUsers`);

/**
 * Action to add a single user to the store.
 *
 * @property {VigilantApiDtosUsersGetResponse} user - The user object to add.
 */
export const AddUser = createAction(`${prefix}AddUser`, props<{ user: VigilantApiDtosUsersGetResponse }>());

/**
 * Action to add multiple users to the store.
 *
 * @property {VigilantApiDtosUsersGetResponse[]} users - An array of user objects to add.
 */
export const AddUsers = createAction(`${prefix}AddUsers`, props<{ users: VigilantApiDtosUsersGetResponse[] }>());

/**
 * Action to update a single user in the store.
 *
 * @property {VigilantApiDtosUsersGetResponse} user - The user object with updated data.
 */
export const UpdateUser = createAction(`${prefix}UpdateUser`, props<{ user: VigilantApiDtosUsersGetResponse }>());

/**
 * Action to update multiple users in the store.
 *
 * @property {VigilantApiDtosUsersGetResponse[]} users - An array of user objects with updated data.
 */
export const UpdateUsers = createAction(`${prefix}UpdateUsers`, props<{ users: VigilantApiDtosUsersGetResponse[] }>());

/**
 * Action to delete a single user from the store.
 *
 * @property {number} id - The unique identifier of the user to be deleted.
 */
export const DeleteUser = createAction(`${prefix}DeleteUser`, props<{ id: number }>());

/**
 * Action to delete multiple users from the store.
 *
 * @property {number[]} ids - An array of unique identifiers for the users to be deleted.
 */
export const DeleteUsers = createAction(`${prefix}DeleteUsers`, props<{ ids: number[] }>());
